import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Typography, Divider, Card } from "antd";
import { toPng } from "html-to-image";
import LandingPage from "../Dashboard/LandingPage";
import NetworkData from "./Network";
import SectionAnalysis from "./Section";
import SimpleMap from "./SimpleMap";
import Scenario from "./Scenario";

const { Content } = Layout;
const { Title } = Typography;

function Singola_Analisi() {
  const { state } = useLocation();
  const dataJson = state?.dataJson || {};
  const [selectedId, setSelectedId] = useState(null);
  const homeRef = useRef(null);

  const captureHome = () => {
    if (homeRef.current) {
      toPng(homeRef.current, { cacheBust: false })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = "home-image.png";
          link.href = dataUrl;
          link.click();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        background: "#fff",
        "--ant-primary-color": "#353A0A",
      }}
    >
      <Content ref={homeRef} style={{ padding: "24px" }}>
        <LandingPage />

        {/* Scenario */}
        <Divider
          orientation="center"
          style={{ borderColor: "#353A0A", fontWeight: "600" }}
        >
          <Title level={4} style={{ margin: 0, color: "#353A0A" }}>
            Analisi Scenario
          </Title>
        </Divider>

        <Scenario
          dataJson={dataJson}
          setSelectedId={setSelectedId}
          captureHome={captureHome}
        />

        {selectedId && (
          <>
            {/* Rete */}
            <Divider
              orientation="center"
              style={{ borderColor: "#353A0A", fontWeight: "600" }}
            >
              <Title level={4} style={{ margin: 0, color: "#353A0A" }}>
                Analisi Rete
              </Title>
            </Divider>
            <Card bordered style={{ marginBottom: 24 }}>
              <NetworkData selectedId={selectedId} dataJson={dataJson} />
            </Card>

            {/* Nodo */}
            <Divider
              orientation="center"
              style={{ borderColor: "#353A0A", fontWeight: "600" }}
            >
              <Title level={4} style={{ margin: 0, color: "#353A0A" }}>
                Analisi Nodo
              </Title>
            </Divider>
            <Card bordered style={{ marginBottom: 24 }}>
              <SimpleMap selectedIdScenario={selectedId} />
            </Card>

            {/* Sezione */}
            <Divider
              orientation="center"
              style={{ borderColor: "#353A0A", fontWeight: "600" }}
            >
              <Title level={4} style={{ margin: 0, color: "#353A0A" }}>
                Analisi Sezione
              </Title>
            </Divider>
            <Card bordered>
              <SectionAnalysis
                selectedIdScenario={selectedId}
                data={dataJson}
              />
            </Card>
          </>
        )}
      </Content>
    </Layout>
  );
}

export default Singola_Analisi;
